export const ILH_ROUTES = {
  BASE: "ilh",
  REINSTATEMENT: "reinstatement",

  AGENT: {
    CLIENT_INQUIRY: "ilhclientinquiry",
    CLIENT_INQUIRY_DETAIL: "details",
    RECENTLY_LAPSED: "ilhrecentlylapsed",
    PENDING_REASONS: "ilhpendingreasons",
    PENDING_REASON_DETAILS: "details",
    PERSISTENCY_REPORT: "ilhpersistencyreport",
    PERSISTENCY_REPORT_DETAILS: "details",
    RECENTLY_LAPSED_DETAILS: "ilhlapseddetails",
    AGENT_BALANCES: "ilhagentbalances",
    APPLICATONS: "ilhapplications",
    E_APPLICATIONS_INFO: "ilhapplicationproduct",
    PREMIUM_CALCULATOR: "ilhpremiumcalculator",

    // SPJ
    PERSISTENCY_REPORT_TAB: "ilhpersistencyreporttab",

    // PWL
    PRODUCTION_REPORT: "ilhprodreport",
    LEADS: "leads",
    LEADS_DETAILS: "details"
  },

  MEMBER: {
    MEMBER_POLICY_INQUIRY: "ilhmemberpolicyinquiry",
    MEMBER_POLICY_INQUIRY_DETAIL: "details",
    MEMBER_POLICY_INQUIRY_COVERAGE_REQUEST: "changerequest",
    MEMBER_POLICY_INQUIRY_ADDRESS_REQUEST: "addressrequest",
    MEMBER_POLICY_INQUIRY_POLICY_REQUEST: "policyloanrequest"
  },

  GROUP: {
    POLICY_INQUIRY: "ilhgrouppolicyinquiry",
    POLICY_INQUIRY_DETAIL: "details",
    MONTHLY_SPREADSHEET: "ilhmonthlyspreadsheet"
  },

  BENEFICIARY: {
    DIRECT_DEPOSIT: "ilhdirectdeposit"
  }
};
